/**
 * 한 줄로 세우는 큐.
 *
 * 왜 필요한가: **오라클 세션은 한 번에 한 문장만 돈다.** 독립 연결 창이 자기 세션을
 * 갖게 되면서(`hooks/useOwnConnSession`), 창이 조회를 동시에 쏘면 서버가 409 busy 로
 * 거절한다 — 자원 분석은 열 때 다섯 개를 한꺼번에 쏜다.
 *
 * 우리가 더하는 제약이 아니라 세션의 성질이라, 화면이 줄을 세워 주는 것이 맞다.
 */
export default function createSerialQueue() {
    let tail = Promise.resolve();

    /**
     * @param {function} thunk 실행할 일 (promise 를 돌려준다)
     * @returns {Promise} thunk 의 결과 — **실패는 그대로 호출자에게 간다**
     */
    return function run(thunk) {
        // 앞 일이 성공하든 실패하든 다음으로 넘어간다.
        // 한 번 실패했다고 줄이 멈추면 창이 통째로 굳는다.
        const next = tail.then(thunk, thunk);
        // 꼬리는 실패를 삼킨다 — 삼키지 않으면 처리되지 않은 거부(unhandled rejection)가 된다.
        // 호출자가 받는 `next` 는 그대로 실패하므로 오류가 사라지지는 않는다.
        tail = next.then(() => undefined, () => undefined);
        return next;
    };
}
